/**
 * Builds the case-details subtitle line shown under the breadcrumb in the
 * Report Studio case-detail header, e.g.
 *   "Examinee: Samantha Jones • Claim: 123456789 • Workers Compensation"
 *
 * Segments with missing/empty values are omitted (including the leading
 * label), so a case without a `service_type` simply drops that segment and
 * its separator. Returns an empty string when nothing is available.
 */
export const buildCaseSubtitle = ({
  examineeName,
  claimNumber,
  serviceType,
}: {
  examineeName?: string | null;
  claimNumber?: string | null;
  serviceType?: string | null;
}): string => {
  const segments: string[] = [];

  if (examineeName?.trim()) {
    segments.push(`Examinee: ${examineeName.trim()}`);
  }
  if (claimNumber?.trim()) {
    segments.push(`Claim: ${claimNumber.trim()}`);
  }
  if (serviceType?.trim()) {
    segments.push(serviceType.trim());
  }

  return segments.join(" • ");
};
